import { Injectable } from '@angular/core';
import { PrintCardContentViewModel } from '../../shared/print-card-content-view-model';

@Injectable()
export class HarlequinBusinessCardStackContentViewModel extends PrintCardContentViewModel {}
